import React from 'react';
import { number, string, bool } from 'prop-types';
import { Box, Text, Heading, Center } from '@chakra-ui/react';

function CountItem({ number, text }) {
  return (
    <Box
      width={{'3sm': "70px", '1sm': "60px", sm: "45px", base:"40px"}}
      height="90px"
      textAlign="center"
      display="flex"
      alignItems="center"
      justifyContent="center"
    >
      <Center>
        <Center flexDir="column">
          <Heading fontSize="4xl" fontWeight="normal" color="secondaryColorText">
            {number}
          </Heading>
          <Text fontSize="xs"color="mainColorText">
            {text}
          </Text>
        </Center>
      </Center>
    </Box>
  );
}

CountItem.propTypes = {
  number: number.isRequired,
  text: string.isRequired,
  isSeconds: bool,
};


export default React.memo(CountItem);
